import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField, required, number, renderCheckbox, renderTextArea} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getCastConfigs } from "../../../actions/actionCast";
import { getGroups } from "../../../actions/actionGroup";
import { getImages } from "../../../actions/actionImage";
import SelectInput from "../../../components/SelectInput";
import { getLicenseStatus} from "../../../actions/actionFooter";


class CastConfigFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentCast: {},
            collapseAdvanced: false,
            urlField: "",
            licensed: false
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleUrlChange = this.handleUrlChange.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);
    }

    toggleAdvanced() {
        this.setState({collapseAdvanced: !this.state.collapseAdvanced})
    }


    submitApi(userData) {
        if (this.props.fromUpdate) {
            userData.cast_config_id = this.state.currentCast && this.state.currentCast.cast_config_id;
            this.props.updateCastConfig(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createCastConfig(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateCastError} = this.props;
        if(updateCastError){
            NotificationManager.error(updateCastError,"Update Casting Config", 3000);
        }
        else{
            NotificationManager.success("Casting Config Updated", "Successfully Updated Casting Config");
            this.props.history.push("/cast");
        }
    }

    handleUpdateError(){
        const {updateCastError} = this.props;
        if(updateCastError){
            NotificationManager.error(updateCastError,"Update Casting Config", 3000);
        } else
            NotificationManager.error("Update Casting Config Failed", "Update Casting Config", 3000);
    }

    handleCreateSuccess(){
        const {createCastError} = this.props;
        if(createCastError){
            NotificationManager.error(createCastError,"Create Casting Config", 3000);
        }
        else{
            NotificationManager.success("Casting Config Created", "Successfully Created Casting Config");
            this.props.history.push("/cast");
        }
    }
    handleUrlChange(e) {
        this.setState({urlField: e.target.value});
    }

    handleCreateError(){
        const {createCastError} = this.props;
        if(createCastError){
            NotificationManager.error(createCastError,"Create Casting Config", 3000);
        } else
            NotificationManager.error("Create Casting Config Failed","Create Casting Config", 3000);
    }

    cancelButton(){
        this.props.history.push("/cast");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.cast_configs && nextProps.cast_configs.length > 0 && this.props.cast_configs !== nextProps.cast_configs && this.props.getCastLoading && this.props.fromUpdate){
            let currentCast = nextProps.cast_configs.find(cast => cast.cast_config_id === this.props.castConfigId);
            this.setState({currentCast: currentCast, urlField : currentCast && currentCast.key ? currentCast.key : ''});
            this.props.initialize({
                image_id: currentCast.image_id,
                group_id: currentCast.group_id,
                allowed_referrers: currentCast.allowed_referrers ? currentCast.allowed_referrers.join('\n') : '',
                limit_sessions: currentCast.limit_sessions,
                session_remaining: currentCast.session_remaining,
                limit_ips: currentCast.limit_ips,
                ip_request_limit: currentCast.ip_request_limit,
                ip_request_seconds: currentCast.ip_request_seconds,
                error_url: currentCast.error_url,
                enable_sharing: currentCast.enable_sharing,
                disable_control_panel: currentCast.disable_control_panel,
                disable_tips: currentCast.disable_tips,
                disable_fixed_res: currentCast.disable_fixed_res,
                key: currentCast.key,
                allow_resume: currentCast.allow_resume,
                allow_anonymous: currentCast.allow_anonymous,
                require_recaptcha:currentCast.require_recaptcha,
                kasm_url:currentCast.kasm_url,
                dynamic_kasm_url:currentCast.dynamic_kasm_url,
                dynamic_docker_network:currentCast.dynamic_docker_network,
            });
        }
    }

    componentDidMount() {
        this.props.getImages();
        this.props.getGroups();
        if (this.props.fromUpdate) {
            this.props.getCastConfigs();
        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('session_casting') >= 0 ){
                    this.setState({licensed: true});
                }
            });

    }


    render() {
        const {handleSubmit, images, groups, castFormValues, has_allow_anonymous , has_limit_ips, has_limit_sessions} = this.props;
        let optionsImages = [];
        images.map(opt => {
            optionsImages.push({label: opt.friendly_name, value: opt.image_id});
        });
        let optionsGroups = [];
        groups.map(opt => {
            optionsGroups.push({label: opt.name, value: opt.group_id});
        });

        optionsImages.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);
        optionsGroups.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

         if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }


        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="url" className="requiredasterisk">URL Key </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="key"
                                       id="key"
                                       component={renderField}
                                       validate={required}
                                       onChange={this.handleUrlChange}
                                />

                            </Col>
                        </Row>
                        <Row><Col>
                            <div
                                className="auto-url">{ "https://" + window.location.host + "/#/cast/" + this.state.urlField}</div>
                        </Col></Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="image_friendly_name" className="requiredasterisk">Image </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="image_id"
                                       selectedValue={castFormValues && castFormValues.image_id ? castFormValues.image_id : ""}
                                       options={optionsImages}
                                       validate={required}
                                       isUpdateForm={this.props.fromUpdate}
                                       component={SelectInput}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="allow_resume">Allow Resume</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="checkbox"
                                               name="allow_resume"
                                               id="allow_resume"
                                               component={renderCheckbox}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="allow_anonymous">Allow Anonymous </Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="checkbox"
                                               name="allow_anonymous"
                                               id="allow_anonymous"
                                               component={renderCheckbox}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        { has_allow_anonymous ?
                             <Col>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="require_recaptcha">Require
                                                ReCAPTCHA </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="checkbox"
                                                   name="require_recaptcha"
                                                   id="require_recaptcha"
                                                   component={renderCheckbox}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            : ""
                        }
                        { has_allow_anonymous ?
                            <Col>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="group_id" className="requiredasterisk">Anonymous User
                                                Group </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field name="group_id"
                                                   selectedValue={castFormValues && castFormValues.group_id ? castFormValues.group_id : ""}
                                                   options={optionsGroups}
                                                   validate={has_allow_anonymous ? required : null }
                                                   isUpdateForm={this.props.fromUpdate}
                                                   component={SelectInput}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            : ""
                        }

                    </Row>
                    <Row>
                        <Col sm="4">
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="limit_sessions">Limit Total
                                            Sessions </Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="checkbox"
                                               name="limit_sessions"
                                               id="limit_sessions"
                                               component={renderCheckbox}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        { has_limit_sessions ?
                            <Col sm="4">
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="session_remaining" className="requiredasterisk">Sessions
                                                Remaining </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="number"
                                                   name="session_remaining"
                                                   id="session_remaining"
                                                   component={renderField}
                                                   validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            : ""
                        }
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="limit_ips">Limit Requests Per IP</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="checkbox"
                                               name="limit_ips"
                                               id="limit_ips"
                                               component={renderCheckbox}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        { has_limit_ips ?
                            <Col>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="ip_request_limit" className="requiredasterisk">Sessions Allowed </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="number"
                                                   name="ip_request_limit"
                                                   id="ip_request_limit"
                                                   component={renderField}
                                                   validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            : ""
                        }
                        { has_limit_ips ?
                            <Col>
                                <FormGroup>
                                    <Row>
                                        <Col>
                                            <Label htmlFor="ip_request_seconds" className="requiredasterisk">Within Seconds </Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Field type="number"
                                                   name="ip_request_seconds"
                                                   id="ip_request_seconds"
                                                   component={renderField}
                                                   validate={number}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            : ""
                        }
                    </Row>
                    <a onClick={this.toggleAdvanced}>
                        <strong>Advanced</strong>
                        <span className="float-right">
                                {this.state.collapseAdvanced ? <i className="fa fa-chevron-down"/> :
                                    <i className="fa fa-chevron-up"/>}
                            </span>
                    </a>
                    <Collapse isOpen={this.state.collapseAdvanced}>
                        <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="kasm_url">Kasm URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="kasm_url"
                                       id="kasm_url"
                                       component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="dynamic_kasm_url">Allow Dynamic Kasm URL Parameter </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                           name="dynamic_kasm_url"
                                           id="dynamic_kasm_url"
                                           component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                         <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="dynamic_docker_network">Allow Dynamic Docker Network URL Parameter </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                           name="dynamic_docker_network"
                                           id="dynamic_docker_network"
                                           component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="error_url">Error URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="error_url"
                                       id="error_url"
                                       component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm="3">
                                    <Label htmlFor="disable_control_panel">Disable Control
                                        Panel </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                           name="disable_control_panel"
                                           id="disable_control_panel"
                                           component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm="3">
                                    <Label htmlFor="disable_tips">Disable Tips </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                           name="disable_tips"
                                           id="disable_tips"
                                           component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm="3">
                                    <Label htmlFor="enable_sharing">Enable Sharing </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                           name="enable_sharing"
                                           id="enable_sharing"
                                           component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm="5">
                                    <Label htmlFor="disable_fixed_res">Disable Shared Fixed
                                        Resolution </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="checkbox"
                                           name="disable_fixed_res"
                                           id="disable_fixed_res"
                                           component={renderCheckbox}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm="5">
                                    <Label htmlFor="allowed_referrers">Restrict To Referrers (One Per Line) </Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="text"
                                           name="allowed_referrers"
                                           id="allowed_referrers"
                                           component={renderTextArea}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                    </Collapse>

                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" 
                        className="cancel-button"
                        size="sm" color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit" size="sm"
                        className="submit-button" 
                        color="primary">
                            Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

CastConfigFormTemplate.proptypes = {
    createCastConfig: Proptypes.func,
    updateCastConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let CastConfigFormWithRouter = withRouter(CastConfigFormTemplate);


const selector = formValueSelector('CastConfigForm');

let CastConfigForm =  connect(state =>{

            const has_allow_anonymous = selector(state, 'allow_anonymous');
            const has_limit_sessions = selector(state, 'limit_sessions');
            const has_limit_ips = selector(state, 'limit_ips');

            return {
                has_allow_anonymous,
                has_limit_sessions,
                has_limit_ips,
                createCastError: state.cast.createCastError,
                createCastLoading: state.cast.createCastLoading,
                createdCast: state.cast.createdCast,
                updateCastError: state.cast.updateCastError,
                updateCastLoading: state.cast.updateCastLoading,
                updatedCast: state.cast.updatedCast,
                cast_configs: state.cast.cast_configs,
                getCastLoading: state.cast.getCastLoading || false,
                images: state.images.images || [],
                groups: state.groups.groups || [],
                castFormValues: state.form && state.form.CastConfigForm && state.form.CastConfigForm.values ? state.form.CastConfigForm.values : null,
                license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,

            }
    },

    dispatch =>
        ({
            getCastConfigs: () => dispatch(getCastConfigs()),
            getImages: () => dispatch(getImages()),
            getGroups: () => dispatch(getGroups()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        }))(CastConfigFormWithRouter);

export default reduxForm({
    form: "CastConfigForm",
})(CastConfigForm);


// WEBPACK FOOTER //
// ./src/views/CastConfig/CastConfigForm/CastConfigForm.js